const Sentry = require('@sentry/browser');
const { initSentry } = require('lib/sentry');
const config = require('Cloud/config');

const IS_ONPREMISE = config.get('ON_PREMISE');

if (!IS_ONPREMISE) {
    window.Sentry = Sentry;

    initSentry({
        dsn: config.get('SENTRY_DSN'),
        build: config.get('BUILD'),
        environment: config.get('ENVIRONMENT'),
        sampleRate: 1,
        buildUrl: config.get('BUILD_URLS').js,
        feature: config.get('FEATURES').configs.sentry,
        user: config.get('user.email'),
    });
}
